// Project imports;
import PageHeader from 'components/PageHeader';

// Hooks

// Types
import ListCreateButton from 'components/buttons/ListCreateButton';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import EmployeesTable from './EmployeesTable';

// ==============================|| EMPLOYEES LIST PAGE ||============================== //

const EmployeesPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'employees.colleagues'}
                    showBreadcrumb
                    buttons={
                        <ListCreateButton
                            permissions={['CREATE.EMPLOYEES']}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => navigateWithReturn(`/employee/new`)}
                            labelId="employees.add-new-employee"
                            newLabelId="new-entity.employee"
                        />
                    }
                />
                <EmployeesTable />
            </div>
        </PaddedLayout>
    );
};

export default EmployeesPage;
